<template>
	<div v-if="loading">
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><i class="fa fa-paper-plane fa-13"></i> ตั้งค่าผู้ส่ง</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12 col-md-12">
				<!-- <div class="d-flex flex-row mr-5"> -->
				<div class="row">
					<div class="align-self-center ml-3" filter="sender_name">เลือกการค้นหา</div>
					<div class="col-12 col-md-3 p-2">
						<select class="browser-default custom-select" v-model="seachSelect">
							<option selected value="null">ทั้งหมด</option>
							<option value="1">Sender Name</option>
							<option value="2">Request Date</option>
							<option value="3">White List</option>
						</select>
					</div>
					<div class="col-12 col-md-3 p-2">
						<date-picker class="input-date pr-2" width="250px" valueType="format" lang="en" v-model="searchTxt" v-if="seachSelect == '2'"></date-picker>
						<div class="input-group" v-else>
							<div class="input-group-prepend">
								<span class="input-group-text" id="basic-addon">
									<mdb-icon far icon="edit" />
								</span>
							</div>

							<input type="text" class="form-control" v-model="searchTxt" aria-describedby="basic-addon" width="80%" />
						</div>
					</div>
					<div class="col-12 col-md-4 py-1">
						<button type="button" class="btn btn-search color_white font12" style="font-weight:400; margin-left:-8px" @click="Search()"><i class="fab fa-sistrix"></i> Search</button>
						<router-link to="Setupsenderadd" v-if="data.rows.length - 1 < user.sender">
							<button id="Setupsender" type="button" class="btn btn-add color_white font12" style="font-weight:400;"><i class="fas fa-plus"></i> Add</button>
						</router-link>
						<!-- <button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-times"></i> Cancel</button> -->
					</div>
				</div>
			</div>
		</div>

		<div>
			<mdb-datatable v-if="loading" :arrows="true" :data="data" striped bordered :searching="false" scrollY maxHeight="450px" />
		</div>

		<div class="mt-3">
			<div class="row"></div>
		</div>
		<div class="row justify-content-center mt-3"></div>
	</div>
</template>

<script>
	import $ from 'jquery'
	// import {mdbDatatable} from 'mdbvue'
	import DatePicker from 'vue2-datepicker'
	import moment from 'moment'
	import {mapGetters, mapActions} from 'vuex'
	let no = 0
	export default {
		name: 'Setupsender',
		components: {
			DatePicker,
		},
		data() {
			return {
				loading: false,
				seachSelect: null,
				searchTxt: null,
				searchdate: new Date(),
				id_upload_file: null,
				data: {
					columns: [
						{
							label: '#',
							field: 'id2',
							sort: true,
							format: (value) => {
								no = value - 1
								return value
							},
						},
						{
							label: 'Request Date',
							field: 'date_create',
							sort: true,
							format: (value) => {
								return moment(value).format('YYYY-MM-DD HH:mm:ss')
							},
						},
						{
							label: 'Sender Name',
							field: 'sender_name',
							sort: true,
						},
						{
							label: 'White List',
							field: 'white_list',
							sort: true,
						},
						{
							label: 'Request by',
							field: 'username',
							sort: true,
						},
						{
							label: '',
							field: 'status',
							format: (value) => {
								if (value == 1) {
									return '<div class="rows text-center font500" style="min-width:110px;"><span class="btn-status-yellow text-white">รอยืนยัน</span><span class="btnbtn btn-delete text-white" dataid="' + this.data.rows[no].id + '"><i class="fas fa-times" ></i></span></div>'
								} else {
									let icon = this.data.rows[no].id == 137 ? '<span style="padding-left:32px"></span>' : '<span class="btnbtn btn-delete text-white" dataid="' + this.data.rows[no].id + '"><span class="fas fa-times" ></i></span>'
									return '<div class="rows text-center font500" style="min-width:110px;"><span class="btn-status-green text-white" dataid="' + this.data.rows[no].id + '">ใช้งาน</span>' + icon + '</div>'
								}
							},
						},
					],
					rows: null,
				},
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			clickCallback: function(pageNum) {
				console.log(pageNum)
			},
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			async Search() {
				this.loading = false
				if (this.searchTxt == '') {
					console.log('Ddddddd')
					await this.callApiMotherFucker({
						method: 'post',
						path: '/sender/All',
						data: {},
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
							this.loading = true
						}
					})
				} else {
					this.loading = false
					let payload = {
						type_select: this.seachSelect == '' ? null : this.seachSelect,
						text: this.searchTxt,
					}
					this.searchTxt = null
					await this.callApiMotherFucker({
						method: 'post',
						path: '/sender/query',
						data: payload,
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
						}
						this.loading = true
					})
					// this.data.rows = this.data.rows.filter((val) => {
					// 	if (val[this.seachSelect].search(this.searchTxt) >= 0) {
					// 		return true
					// 	} else if (val[this.seachSelect].search(this.searchdate) >= 0) {
					// 		return true
					// 	}
					// })
					// setTimeout(() => {
					// 	this.loading = true
					// }, 100)
				}
			},
		},
		async mounted() {
			this.loading = false
			this.searchdate = moment(new Date()).format('YYYY-MM-DD')
			await this.callApiMotherFucker({
				method: 'post',
				path: '/sender/All',
				data: {},
			}).then((res) => {
				this.loading = true
				if (res.payload) {
					this.data.rows = this.$add_index(res.payload)
					this.data.rows.forEach((value) => {
						this.data.rows.id_upload_file = [value.id]
					})
				}
			})

			let ieieieiei = this
			$('.btnbtn').on('click', function() {
				let id = $(this).attr('dataid') || 0
				if (id > 0) {
					this.loading = false
					let payload = {
						id: id, //this.data.rows.id_upload_file,
					}
					ieieieiei
						.callApiMotherFucker({
							method: 'delete',
							path: '/sender',
							data: payload,
						})
						.then((res) => {
							console.log('ress', res)

							ieieieiei.$swal({
								icon: 'success',
								html: res.msg,
								timer: 8000,
								showConfirmButton: true,
								allowOutsideClick: false,
								allowEscapeKey: false,
							})
							setTimeout(() => {
								location.reload()
							}, 2000)
						})
				}
			})
		},
	}
</script>
<style scoped>
	.fa-13 {
		font-size: 1em;
	}
	.field-icon {
		margin-left: 25px;
		margin-right: 10px;
		margin-top: 0px;
		position: relative;
		z-index: 2;
	}
	.label1 {
		color: red !important;
	}
</style>
